import React from 'react';
import { PostHogProvider } from '@posthog/react';

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  defaults: '2026-01-30',
  loaded: (ph) => {
    const env = process.env.REACT_APP_ENV || (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'local' : 'prod');
    ph.register({ environment: env });
    if (process.env.REACT_APP_POSTHOG_DEBUG === 'true') {
      ph.debug();
    }
  },
};

export function PostHogConfig({ children }) {
  const apiKey = process.env.REACT_APP_POSTHOG_KEY;
  if (!apiKey) {
    return children;
  }
  return (
    <PostHogProvider apiKey={apiKey} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
}
